<template>
  <div class="floating-search">
    <div class="search-button" @click="openSearchModal">
      <el-icon class="search-icon"><Search /></el-icon>
      <span class="search-text">{{ t('search.button') }}</span>
    </div>
    <SearchModal :isVisible="isSearchVisible" @close="closeSearchModal" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Search } from '@element-plus/icons-vue'
import SearchModal from './SearchModal.vue'

const { t } = useI18n()
const isSearchVisible = ref(false)

const openSearchModal = () => {
  isSearchVisible.value = true
}

const closeSearchModal = () => {
  isSearchVisible.value = false
}
</script>

<style scoped lang="scss">
.floating-search {
  position: fixed;
  top: 80px;
  right: 250px;
  z-index: 20;
  width:200px
}
// 搜索框
.search-button {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(12px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  color: #222;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.35);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.search-icon {
  font-size: 18px;
  margin-right: 8px;
}

.search-text {
  font-size: 15px;
}

@media screen and (max-width: 768px) {
  .floating-search {
    top: 15px;
    right: 15px;
  }
  
  .search-button {
    padding: 8px 12px;
  }
  
  .search-icon {
    font-size: 16px;
    margin-right: 6px;
  }
  
  .search-text {
    font-size: 14px;
  }
}

@media screen and (max-width: 576px) {
  .floating-search {
    top: 10px;
    right: 10px;
  }
  
  .search-button {
    padding: 8px 12px;
    border-radius: 6px;
  }
  
  .search-text {
    display: none;
  }
  
  .search-icon {
    margin-right: 0;
  }
}
</style> 